import { CoreContext, Navigation } from "Core";
import { ITextBlockArray, ILanguage } from "Entities";
import { ServiceProvider } from "Service";

export class Login {
    public static viewModel: kendo.data.ObservableObject;

    private static showLanguageSelector: boolean;

    private static textBlockCategory = "login";

    private static container: JQuery;

    private static service: ServiceProvider;

    private static languageDropDown: kendo.ui.DropDownList;

    private static setLanguage(language: string, textblocks: ITextBlockArray, languages: ILanguage[]): void {
        for (let i = 0, len = languages.length; i < len; i++) {
            let tbName = "language" + languages[i].LanguageCode;
            languages[i].LanguageDescription =
                this.service.TextBlock.getChecked(textblocks, tbName, this.textBlockCategory) || languages[i].LanguageDescription;
        }
        if (this.showLanguageSelector) {
            this.viewModel.set("Languages", languages);
            if (this.languageDropDown) {
                this.languageDropDown.refresh();
            }
        }
        this.viewModel.set("TextBlock", textblocks);
        document.title = textblocks["pageTitle"];
    }

    public static initialize(
        container: JQuery,
        showLanguageSelector: boolean,
        defaultLanguage: string,
        uniqueApplicationName: string
    ): Promise<void> {
        this.container = container;
        this.showLanguageSelector = showLanguageSelector;
        CoreContext.configure({
            UniqueApplicationName: uniqueApplicationName
        });
        this.service = CoreContext.serviceProviderInstance;
        this.service.Menu.clearCache();

        this.viewModel = kendo.observable({
            TextBlock: null,
            getTextBlock: function(textBlockName: string) {
                let textBlocks = this.get("TextBlock");
                return CoreContext.serviceProviderInstance.TextBlock.getChecked(textBlocks, textBlockName, this.textBlockCategory);
            },
            isLoaded: false,
            Languages: [],
            SelectedLanguage: null
        });

        this.viewModel.bind("change", (e: any) => {
            if (e.field == "SelectedLanguage") {
                let languageCode = this.viewModel.get("SelectedLanguage").LanguageCode;
                this.service.TextBlock.load(languageCode, this.textBlockCategory).then(textblocks => {
                    this.setLanguage(languageCode, textblocks[this.textBlockCategory], this.viewModel.get("Languages"));
                    this.viewModel.set("isLoaded", true);
                    this.container.removeClass("dms-hidden").addClass("animated fadeIn");
                });
            }
        });
        let loadPromise = this.service.TextBlock.load(defaultLanguage, this.textBlockCategory).then(textblocks => {
            if (this.showLanguageSelector) {
                this.service.Language.get().then(languages => {
                    this.setLanguage(defaultLanguage, textblocks[this.textBlockCategory], languages);
                    let selectedLanguage: ILanguage;
                    for (let i = 0, len = languages.length; i < len; i++) {
                        if (languages[i].LanguageCode == defaultLanguage) {
                            selectedLanguage = languages[i];
                        }
                    }
                    this.viewModel.set("SelectedLanguage", selectedLanguage || languages[0]);
                });
            } else {
                this.setLanguage(defaultLanguage, textblocks[this.textBlockCategory], []);
                this.viewModel.set("isLoaded", true);
                this.container.removeClass("dms-hidden").addClass("animated fadeIn");
            }
        });

        kendo.bind(this.container, this.viewModel);
        let inputUsername = this.container.find("#input-username");
        let inputPassword = this.container.find("#input-password");
        this.languageDropDown = this.container.find("#input-language").data("kendoDropDownList");

        this.container.find("#btnLogin").click(() => {
            if (!inputUsername.val() || !inputPassword.val()) {
                Navigation.errorAsync((<any>this.viewModel).getTextBlock("emptyLoginFields"), "Error");
            } else {
                kendo.ui.progress($("body"), true);
                $("#loginForm").submit();
            }
            return false;
        });

        $("#btnWinLogin").click(() => {
            kendo.ui.progress($("body"), true);
            $("#windows-form").submit();
            return false;
        });

        $("#btnSendPassword").click(() => {
            let userName = $("#input-username").val();
            if (!userName) {
                Navigation.errorAsync((<any>this.viewModel).getTextBlock("usernameMissing"), "Error");
            } else {
                kendo.ui.progress($("body"), true);
                $("#input-username-sendpassword").val(userName);
                $("#form-sendpassword").submit();
            }
            return false;
        });
        return loadPromise;
    }
}
